/*eslint-disable*/
import React, { Component } from 'react'
import { Message } from 'semantic-ui-react'
import APP_CONSTANTS from '../../../config/constants';
import Axios from 'axios';

export default class Services extends Component {

    state = {
        conditionData: [],
        cardId: '',
        amount: 0,
        vehId: ''
    }
    /* UNSAFE_componentWillReceiveProps(nextProps) {
        console.log("KKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK")
        console.log(this.state)
        console.log(this.props)
        console.log(nextProps)

        console.log(this.state.cardId)
        console.log(this.state.amount)
        console.log(this.state.vehId)
        console.log("--------------------------")
        console.log(nextProps.cardTypeId)
        console.log(nextProps.amount)
        console.log(nextProps.vehicleIdrole)

        console.log(+this.state.cardId != +nextProps.cardTypeId)
        console.log(+this.state.amount != +nextProps.amount)
        console.log(+this.state.vehId != +nextProps.vehicleIdrole)
        console.log(+this.state.cardId != +nextProps.cardTypeId || +this.state.amount != +nextProps.amount || +this.state.vehId != +nextProps.vehicleIdrole)
        if (+this.state.cardId != +nextProps.cardTypeId || (+this.state.amount != +nextProps.amount && this.props.mode != 1) || +this.state.vehId != +nextProps.vehicleIdrole) {
            console.log("DDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDd")
            this.getConditionsData(nextProps.cardTypeId, nextProps.amount, nextProps.vehicleIdrole)
            this.setState({
                cardId: nextProps.cardTypeId,
                amount: nextProps.amount,
                vehId: nextProps.vehicleIdrole
            })
        }
    } */

    componentDidUpdate(nextProps) {
        if (+this.state.cardId != +nextProps.cardTypeId || (+this.state.amount != +nextProps.amount && +nextProps.amount > 0) || +this.state.vehId != +nextProps.vehicleIdrole) {
            this.getConditionsData(nextProps.cardTypeId, nextProps.amount, nextProps.vehicleIdrole)
            this.setState({
                cardId: nextProps.cardTypeId,
                amount: nextProps.amount,
                vehId: nextProps.vehicleIdrole
            })
        }
    }

    componentDidMount() {
        this.getConditionsData(this.props.cardTypeId, this.props.amount, this.props.vehicleIdrole)
        this.setState({
            cardId: this.props.cardTypeId,
            amount: this.props.ammount,
            vehId: this.props.vehicleIdrole
        })
    }

    getConditionsData = (cardsId, amounts, vehsId) => {

        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let ammount = amounts
        let cardId = cardsId
        let vehId = vehsId
        let data = JSON.stringify
            ({
                api_token: token,
                customerNo: customerNo,
                jobCardTypeId: cardId,
                vehicleId: vehId,
                amount: ammount,
                userId: userId,
            })
        // console.log('cond', data)
        Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getJobCardApproverRole`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            if (response.data.status === 1) {
                this.setState({
                    conditionData: response.data.data
                })
                let arr = []
                response.data.data.map((o) => {
                    arr.push(o.roleId)
                })
                this.props.conditionRoleId(arr)
                this.props.jbConditionId(response.data.data[0])
                this.props.valueForApproval(ammount)
                console.log("Approval Data", response.data)

            } else {
                this.setState({
                    conditionData: []
                })
                this.props.conditionRoleId([])
            }
        }))
            .catch(error => console.log(error))
    }

    render() {
        return (
            <div>
                {this.state.conditionData.length > 0 ?
                    this.state.conditionData.map((object, i) => (
                        <>
                            <Message size="tiny" info icon >
                                <Message.Content>
                                    <p>
                                        Approver: <b>{object.roleName} </b>
                                        {object.conditionName}: <b>{this.props.amount} Rs.</b>
                                    </p>
                                </Message.Content>
                            </Message>
                        </>
                    ))
                    : ''
                }
            </div>
        )
    }
}
